import { Link, useSearchParams } from 'react-router-dom';
import { Mail } from 'lucide-react';

import { BrandedAuthLayout } from '@/layouts/BrandedAuthLayout';
import { Button } from '@marine/ui/button';

export function TenantResetPasswordCheckEmailPage() {
  const [params] = useSearchParams();
  const email = params.get('email');

  return (
    <BrandedAuthLayout variant="dealer">
      <div className="block w-full space-y-5 text-center">
        <div className="flex justify-center">
          <div className="flex h-14 w-14 items-center justify-center rounded-full bg-primary/10 text-primary">
            <Mail className="h-6 w-6" />
          </div>
        </div>

        <div className="space-y-1">
          <h1 className="text-2xl font-semibold tracking-tight">
            Check your email
          </h1>
          <p className="text-sm text-muted-foreground">
            {email ? (
              <>
                We sent a password reset link to{' '}
                <span className="font-medium text-foreground">{email}</span>.
              </>
            ) : (
              'We sent a password reset link to your inbox.'
            )}
            <br />
            Click the link to choose a new password.
          </p>
        </div>

        <div className="text-xs text-muted-foreground">
          Didn&apos;t get an email? Check your spam folder, or{' '}
          <Link
            to="/forgot-password"
            className="font-medium text-foreground hover:text-link"
          >
            try again
          </Link>
          .
        </div>

        <Button asChild variant="outline" className="w-full">
          <Link to="/login">Back to sign in</Link>
        </Button>
      </div>
    </BrandedAuthLayout>
  );
}
